import React from "react";
import PropTypes from "prop-types";
import { graphql, useStaticQuery } from "gatsby";
import Img from "gatsby-image";
import formConfig from "./../../formConfig";
import {
  // FoundationRequestInformationFormElement,
  FoundationRequestWrapper,
} from "./elements";
import { H2SmallStrong, H5Big } from "./../Typography";
import { SmallButton } from "./../Buttons";

const FoundationRequestInformationForm = ({
  useStayInformed,
  storeVersion,
}) => {
  const endpoint = formConfig.getFormEndpoint(
    storeVersion ? "toteEndpoint" : "foundationRequestEndpoint"
  );
  const requestInformationQuery = useStaticQuery(graphql`
    query {
      craftFoundationFrontFoundationFrontEntry {
        foundationStayInformedBackgroundImage {
          ... on Craft_communityAssets_Asset {
            localFile {
              publicURL
              childImageSharp {
                fixed(fit: COVER, width: 1440, height: 377) {
                  src
                  ...GatsbyImageSharpFixed
                }
              }
            }
          }
        }
        foundationRequestInformationBackgroundImage {
          ... on Craft_communityAssets_Asset {
            localFile {
              publicURL
              childImageSharp {
                fixed(fit: COVER, width: 1440, height: 377) {
                  src
                  ...GatsbyImageSharpFixed
                }
              }
            }
          }
        }
      }
    }
  `).craftFoundationFrontFoundationFrontEntry;
  // console.log(requestInformationQuery);
  const myImage = useStayInformed
    ? requestInformationQuery.foundationStayInformedBackgroundImage[0].localFile
        .childImageSharp.fixed
    : requestInformationQuery.foundationRequestInformationBackgroundImage[0]
        .localFile.childImageSharp.fixed;
  // console.log(myImage);
  // TODO: separate out these two things?
  return (
    <FoundationRequestWrapper>
      <Img fixed={myImage} />
      <div>
        <div>
          <H2SmallStrong>
            {useStayInformed
              ? ""
              : useStayInformed
              ? "Get in touch"
              : "Request information"}
          </H2SmallStrong>
          <H5Big>
            {useStayInformed ? (
              <React.Fragment>
                Feeling inspired by our programmes or want to participate in our
                events? We’re interested in learning more about your projects.
                Get in touch or learn about eligibility here.
                <br />
              </React.Fragment>
            ) : (
              "Sign up to learn more about our residencies, research grants, projects and programming"
            )}
          </H5Big>
          <a href="mailto:info@alserkalartsfoundation.ae">
            <SmallButton>Get in touch</SmallButton>
          </a>
        </div>
        {/*
        <FoundationRequestInformationFormElement action={endpoint}>
          <p>
            <label>
              First Name<input type="text" name="First Name" required></input>
            </label>
            <span>&nbsp;</span>
            <label>
              Family Name<input type="text" name="Family Name" required></input>
            </label>
          </p>
          <p>
            <label>
              Email address
              <input type="email" name="Email address" required></input>
            </label>
          </p>
          <input type="submit" value="send" name="Send" />
					</FoundationRequestInformationFormElement>*/}
      </div>
    </FoundationRequestWrapper>
  );
};

export default FoundationRequestInformationForm;

FoundationRequestInformationForm.propTypes = {
  useStayInformed: PropTypes.bool,
  storeVersion: PropTypes.bool,
};
